"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdUploadUrl = getAdUploadUrl;
async function getAdUploadUrl(advertisingRepo, file) {
    return advertisingRepo.getAdUploadUrl(file);
}
